import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSingleInsightBorderPositive = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M30.0322 7.45692C30.9259 7.86207 31.5 8.7526 31.5 9.73387V33C31.5 33.8284 30.8284 34.5 30 34.5H4C3.17157 34.5 2.5 33.8284 2.5 33V9.73387C2.5 8.7526 3.07406 7.86207 3.96778 7.45692L16.3807 1.82974C16.7743 1.65131 17.2257 1.65131 17.6193 1.82974L30.0322 7.45692Z" })
});
export default SvgSingleInsightBorderPositive;
